import { render } from "./postcode.vue?vue&type=template&id=77686c32"
import script from "./postcode.vue?vue&type=script&lang=js"
export * from "./postcode.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/form/field/postcode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77686c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77686c32', __exports__)) {
    console.log('reload')
    api.reload('77686c32', __exports__)
  }
  
  module.hot.accept("./postcode.vue?vue&type=template&id=77686c32", () => {
    console.log('re-render')
    api.rerender('77686c32', render)
  })

}


export default __exports__